import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';

import { TemplaterState } from '../';

export const selectTemplater: MemoizedSelector<object, TemplaterState> = createFeatureSelector<TemplaterState>('templater');

